import React from 'react'
import Userdash from '../../components/userdeptdashboardcomponents/Userdash'



function Userdeptdashboard({renderPageContent}) {
    return (
        <>
                        <Userdash renderPageContent={renderPageContent}/>
                       
                       
        </>
    )
}
export default Userdeptdashboard
